import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { UserGuard } from './guards/user-guard/user.guard';
import { LoginGuard } from './guards/login-guard/login.guard';
import { LogoutComponent } from './components/logout/logout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';

export const routes: Routes = [

  { path: 'admin-login', loadComponent: () => import("./components/admin-login/admin-login.component").then(m => m.AdminLoginComponent), canActivate: [LoginGuard] },
  { path: 'login', loadComponent: () => import("./components/user-login/user-login.component").then(m=> m.UserLoginComponent), canActivate: [LoginGuard] },
  { path: 'logout', component: LogoutComponent },

  { path: "ashwagandha", loadComponent: () => import("./components/comming-soon/comming-soon.component").then(m => m.CommingSoonComponent) },
  { path: "shilajit", loadComponent: () => import("./components/comming-soon/comming-soon.component").then(m => m.CommingSoonComponent) },
  { path: "herbal-teas", loadComponent: () => import("./components/comming-soon/comming-soon.component").then(m => m.CommingSoonComponent) },
  { path: "new-arrivals", loadComponent: () => import("./components/comming-soon/comming-soon.component").then(m => m.CommingSoonComponent) },
  { path: "best-sellers", loadComponent: () => import("./components/comming-soon/comming-soon.component").then(m => m.CommingSoonComponent) },


  {
    path: "",component: UserLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) },
      { path: 'about-us', loadComponent: () => import('./components/about/about.component').then(m => m.AboutComponent) },
      { path: "shop", loadComponent: () => import('./components/products/products.component').then(m => m.ProductsComponent) },
      { path: "shop/:productId", loadComponent: () =>  import('./components/product-details/product-details.component').then(m => m.ProductDetailsComponent) },
      { path: "lab-reports", loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent) },
    ]
  },

  {
    path: 'admin', component: AdminLayoutComponent,
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [UserGuard]
  },

  {
    path: 'user', component: UserLayoutComponent,
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
  },

  { path: '**', redirectTo: 'not-found' },
  {  path: 'not-found', loadComponent: () => import("./components/not-found/not-found.component").then(matchMedia=> matchMedia.NotFoundComponent) }, // Replace with your NotFoundComponent

];
